export default __webpack_public_path__ + "static/media/hair-cold-winter.154589b4.png";